
/**
 * 19 Dic 2024      Javier Calderon     Se Modulariza
 * 
 */

import React, { useEffect, useState } from 'react';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import { Col, Row, Button, Modal, CloseButton, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';


const ModalPagoStripe = (
    {
        showPagoModal,
        setShowPagoModal,
        orden,
        setLinksPagos,

        setGenerandoLink,

        GuardarComentario
    }
) => {

    const { token, setToken, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [cargando] = useState(false);
    const [dTotalLinkPago, setdTotalLinkPago] = useState('0.0000');
    const [iBotonMostrar, setIBotonMostrar] = useState(0);


    useEffect(
        () => {
            setdTotalLinkPago(orden.dSaldoInsoluto);
        }
        , []);


    /**
       * Genera el link del pago
       * @param {any} totalLinkPago
       */
    const generarLinkPagoStripe = async (totalLinkPago) => {

        setShowPagoModal(false);
        setGenerandoLink(true);

        var jDataSend =
        {
            idOrden: orden.idOrden, // ID de la orden proporcionada como parámetro
            idCatFormaPago: orden.idCatFormaPago,
            dSaldoAnterior: orden.dSaldoInsoluto,
            dMonto: totalLinkPago, // Monto en centavos (por ejemplo, $100.00)
            vMoneda: orden.vMoneda, // Moneda (ejemplo: dólares estadounidenses)
            iBotonMostrar: iBotonMostrar // 0: Ambos, 1: Stripe, 2: PayPal

        };

        console.log("DataSend -> ", jDataSend);

        const response = await fetch("/api/orden/stripe_GeneraLinkPago", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        })
            .catch((error) => {
                
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log("==== Links Pagos Stripe ====");
            console.log(response);
            const data = await response.json();
            console.log("Response Link de pagos Stripe -> ", data);

            if (data.iResponseType == 1) {
                let vUUIDLinkPago = (data.detalles);

                //Se coloca el link
                setLinksPagos((prevLinks) => [

                    {
                        idLinkPago: data.vCode, // id del Link
                        vUUIDLinkPago: vUUIDLinkPago, // UUID del link
                        vMoneda: orden.vMoneda, // Moneda
                        iStatus: 0, // iStatus
                        dTotalPago: totalLinkPago, // Total del pago
                        iBotonMostrar: iBotonMostrar,
                        dCreatedDate: new Date().toISOString()// Fecha de creacion
                    },
                    ...prevLinks
                ]);

                var totalMoneda = parseFloat(totalLinkPago).toLocaleString(
                    orden.vMoneda == "MXN" ? "es-MX" : "en-US",
                    { maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: orden.vMoneda }
                ) + " " + orden.vMoneda;
               
                
                GuardarComentario(orden.idOrden, "<b>" + nombreCompleto + "</b> <b class='badge badge-soft-success'>generó </b> un Link de pago <b> # " + data.vCode + " de " + totalMoneda + "</b>", 2, orden, () => {
                    // Comentario guardado exitosamente
                });

                showSuccessToast(data.vMessage);

            } else {
                showErrorToast(data.vMessage);
            }

            setGenerandoLink(false);
        }
        else {
            setGenerandoLink(false);
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    return (
        <>
            <Modal
                show={showPagoModal}
                onHide={() => { setShowPagoModal(false); }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">Escribe el total del pago</Modal.Title>
                    {cargando ?
                        <Skeleton />
                        :
                        <CloseButton
                            className="btn btn-circle btn-sm transition-base p-0"
                            onClick={() => { setShowPagoModal(false); }}
                        />
                    }
                </Modal.Header>
                <Modal.Body>

                    <Row className="gx-3">
                        <Col>
                            {cargando ? (
                                <Skeleton />
                            ) : (
                                <div>
                                    {
                                        orden.bIsPagada ? (
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="me-3 text-break">
                                                    <strong>VENTA TOTALMENTE PAGADA</strong>
                                                </span>
                                            </div>
                                        ) : (
                                            <>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semi-bold">Total a pagar</Form.Label>
                                                    <CurrencyInput
                                                        className="form-control"
                                                        defaultValue={orden.dSaldoInsoluto}
                                                        decimalsLimit={4}
                                                        prefix="$ "
                                                        onValueChange={(value) => setdTotalLinkPago(value)}
                                                        disabled={orden.idCatFormaPago !== 22}
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-4">
                                                    <Form.Label className="fw-semi-bold">Botón(es) de pago a mostrar</Form.Label>
                                                    <Form.Select
                                                        value={iBotonMostrar}
                                                        onChange={(e) => setIBotonMostrar(Number(e.target.value))}
                                                        className="form-select"
                                                    >
                                                        <option value={0}>Ambos (Stripe y PayPal) - Por defecto</option>
                                                        <option value={1}>Solo Stripe (Tarjeta)</option>
                                                        <option value={2}>Solo PayPal</option>
                                                    </Form.Select>
                                                    <Form.Text className="text-muted fs--2">
                                                        {iBotonMostrar === 0 && "Se mostrarán los botones de Stripe y PayPal en la página de pago."}
                                                        {iBotonMostrar === 1 && "Solo se mostrará el botón de Stripe (tarjeta) en la página de pago."}
                                                        {iBotonMostrar === 2 && "Solo se mostrará el botón de PayPal en la página de pago."}
                                                    </Form.Text>
                                                </Form.Group>

                                                <div className="d-flex justify-content-end">
                                                    <Button
                                                        variant="secondary"
                                                        className="btn-sm me-2"
                                                        onClick={() => { setShowPagoModal(false); }}
                                                    >
                                                        Cancelar
                                                    </Button>
                                                    <Button
                                                        onClick={() => generarLinkPagoStripe(dTotalLinkPago)}
                                                        className="btn btn-falcon-primary btn-sm"
                                                    >
                                                        Generar Link
                                                    </Button>
                                                </div>
                                            </>
                                        )
                                    }
                                </div>

                            )}
                        </Col>
                    </Row>


                </Modal.Body>



            </Modal>
        </>

    );
};

ModalPagoStripe.propTypes = {

    showPagoModal: PropTypes.bool,
    setShowPagoModal: PropTypes.func,
    orden: PropTypes.array,
    setLinksPagos: PropTypes.func,

    setGenerandoLink: PropTypes.func,

    GuardarComentario: PropTypes.func

};

export default ModalPagoStripe;
